import React, { useState } from "react"
import { Form, message } from "antd"
import { 
    useDispatch, 
    useSelector } from "react-redux";
import { useNavigate } from 'react-router';

import { ROUTES, COMMON_FEATURES } from "../../../../../../../constants"

// Components
import showSecondarySidebar from "../../../../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../../../../components/Decoration/Page"
import ServiceEntryForm from "./ServiceEntryForm"

import { v3_vamEntries } from '../../../../../../../services/redux/actions'

// Services
import { 
    REDUX,
    TIME 
 } from '../../../../../../../services/util'

// Style

const { dayJSMilliSecond } = TIME

const ServiceEntryAdd = () => {

    const [ form ] = Form.useForm()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [ messageApi, contextHolder] = message.useMessage();

    const vamReminders = useSelector(REDUX.reduxStoreWrapper('vamReminders.reminderByID'))

    const [images, setImages] = useState([])
    const [check, setCheck] = useState({})

    const onFinish = e => {
        const { vid, vamlid } = e

        const vamrid = Object.values(vamReminders).find(v => v.vid === vid && v.vamlid === vamlid)

        const items = { 
            ...e, 
            completedAt: dayJSMilliSecond(e.completedAt), 
            ...(check?.issue ? { issuedAt: dayJSMilliSecond(e.issuedAt) } : {}),
            ...(check?.reminder ? { nextVamReminders: { time_next: dayJSMilliSecond(e.time_next), vamrids: [vamrid] }} : {} ),
        }
        delete items.photos; 

        messageApi.open({
            type: "loading",
            content: "Creating new service entry...",
            duration: 0,
          });

        dispatch(v3_vamEntries.cu_vam_entry_request({ actionAPI: 'C', ...items, ...(images?.length ? { photos: images } : {})}, 
        () => {messageApi.destroy(); navigate(ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.VEHICLE_ENTRY_MANAGEMENT])}))
    }

    const items = { form, onFinish, images, setImages, check, setCheck, vamReminders }

    return (
        <div className="page-container">
            {contextHolder}
            <Page title="Add New Service Entry">
                <ServiceEntryForm {...items}/>
            </Page>
        </div>
    )
}

const MemoizedServiceEntryAdd = React.memo(ServiceEntryAdd);

export default showSecondarySidebar(false)(MemoizedServiceEntryAdd);